import { render, staticRenderFns } from "./AppDetailHeader.vue?vue&type=template&id=49853e5d&scoped=true"
import script from "./AppDetailHeader.vue?vue&type=script&lang=js"
export * from "./AppDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./AppDetailHeader.vue?vue&type=style&index=0&id=49853e5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49853e5d",
  null
  
)

export default component.exports